// Transaction Service - GraphQL operations for Transactions
import { graphqlClient } from '../graphqlClient';

// ==================== Admin Transactions ====================

export const getAllTransactions = async () => {
  const query = `
    query GetAllTransactions {
      getAllTransactions {
        id
        transaction_id
        merchant_ref
        type
        status
        amount
        fee_amount
        net_amount
        currency
        payment_method
        provider_code
        provider_ref
        merchant_id
        merchant_code
        merchant_name
        reseller_id
        reseller_code
        reseller_name
        engine_id
        engine_code
        customer_id
        customer_name
        customer_email
        customer_phone
        bank_code
        bank_account
        routing_attempts
        error_message
        callback_status
        callback_attempts
        callback_last_attempt
        created_date
        processed_at
        completed_at
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.query(query);
  return result.getAllTransactions || [];
};

// ==================== Merchant Transactions ====================

export const getMerchantTransactions = async () => {
  const query = `
    query GetMerchantTransactions {
      merchantTransactions {
        id
        transaction_id
        merchant_ref
        type
        status
        amount
        fee_amount
        net_amount
        currency
        payment_method
        provider_code
        provider_ref
        merchant_id
        merchant_code
        merchant_name
        reseller_id
        reseller_code
        reseller_name
        engine_id
        engine_code
        customer_id
        customer_name
        customer_email
        customer_phone
        bank_code
        bank_account
        routing_attempts
        error_message
        callback_status
        callback_attempts
        callback_last_attempt
        created_date
        processed_at
        completed_at
        admin_note
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.query(query);
  return result.merchantTransactions || [];
};

// ==================== Reseller Transactions ====================

export const getResellerTransactions = async () => {
  const query = `
    query GetResellerTransactions {
      resellerTransactions {
        id
        transaction_id
        merchant_ref
        type
        status
        amount
        fee_amount
        net_amount
        currency
        payment_method
        provider_code
        provider_ref
        merchant_id
        merchant_code
        merchant_name
        reseller_id
        reseller_code
        reseller_name
        engine_id
        engine_code
        customer_id
        customer_name
        customer_email
        customer_phone
        bank_code
        bank_account
        routing_attempts
        error_message
        callback_status
        callback_attempts
        callback_last_attempt
        created_date
        processed_at
        completed_at
        admin_note
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.query(query);
  return result.resellerTransactions || [];
};

// ==================== Engine Transactions ====================

export const getEngineTransactions = async () => {
  const query = `
    query GetEngineTransactions {
      engineTransactions {
        id
        transaction_id
        merchant_ref
        type
        status
        amount
        fee_amount
        net_amount
        currency
        payment_method
        provider_code
        provider_ref
        merchant_id
        merchant_code
        merchant_name
        reseller_id
        reseller_code
        reseller_name
        engine_id
        engine_code
        customer_id
        customer_name
        customer_email
        customer_phone
        bank_code
        bank_account
        routing_attempts
        error_message
        callback_status
        callback_attempts
        callback_last_attempt
        created_date
        processed_at
        completed_at
        admin_note
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.query(query);
  return result.engineTransactions || [];
};

// ==================== Get Transaction By ID ====================

export const getTransactionById = async (id) => {
  const query = `
    query GetTransactionById($id: String!) {
      transactionById(id: $id) {
        id
        transaction_id
        merchant_ref
        type
        status
        amount
        fee_amount
        net_amount
        currency
        payment_method
        provider_code
        provider_ref
        merchant_id
        merchant_code
        merchant_name
        reseller_id
        reseller_code
        reseller_name
        engine_id
        engine_code
        customer_id
        customer_name
        customer_email
        customer_phone
        bank_code
        bank_account
        routing_attempts
        error_message
        callback_status
        callback_attempts
        callback_last_attempt
        created_date
        processed_at
        completed_at
        admin_note
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.query(query, { id });
  return result.transactionById;
};

// ==================== Update Transaction Status (Admin Only) ====================

export const updateTransactionStatus = async (id, status, adminNote) => {
  const mutation = `
    mutation UpdateTransactionStatus($id: String!, $input: UpdateTransactionStatusInput!) {
      updateTransactionStatus(id: $id, input: $input) {
        id
        transaction_id
        merchant_ref
        type
        status
        amount
        fee_amount
        net_amount
        currency
        payment_method
        provider_code
        provider_ref
        merchant_id
        merchant_code
        merchant_name
        reseller_id
        reseller_code
        reseller_name
        engine_id
        engine_code
        customer_id
        customer_name
        customer_email
        customer_phone
        bank_code
        bank_account
        routing_attempts
        error_message
        callback_status
        callback_attempts
        callback_last_attempt
        created_date
        processed_at
        completed_at
        admin_note
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.mutate(mutation, {
    id,
    input: {
      status,
      admin_note: adminNote || null,
    },
  });
  return result.updateTransactionStatus;
};




